"use strict";

import BaseModel from "dias/core/models/baseModel";

class Sachberichtvorlagen extends BaseModel {
  constructor() {
    super("sachberichtvorlagen", {
      subPaths: {
        regeln: "regeln",
      }
    });
  }

  regelnExtendModel(model) {
    model.moveUp = () => model.customPOST({}, "nach_oben");
    model.moveDown = () => model.customPOST({}, "nach_unten");
    model.titel = (model.sbr_nummer ? ("[" + model.sbr_nummer + "] ") : "") + model.sbr_kbez;
    return model;
  }
}

export default Sachberichtvorlagen;
